import React from "react";
import hire from "../HireSection/hire.png";
import Lines from "../HireSection/lines6.png";

const Hire = () => {
  return (
    <section className="my-24 px-4 sm:px-8 lg:px-[105px]">
      <div
        className="
          w-full rounded-3xl bg-[#edf0f6]
          flex flex-col-reverse xl:flex-row
          justify-between items-center
          xl:gap-36 2xl:gap-48
          py-16 xl:py-0
          xl:h-72 relative overflow-hidden
        "
      >
        {/* === Left Text Section === */}
        <div className="flex items-center justify-center w-full text-center xl:text-left">
          <p
            className="
              text-2xl sm:text-3xl xl:text-[35px]
              leading-[40px] sm:leading-[50px] xl:leading-[55px]
              font-[700]
              max-w-[540px] xl:max-w-[530px]
            "
          >
            Hire the best developers and <br /> designers around!
          </p>
        </div>

        {/* === Right Image Section === */}
        <div className="w-full flex justify-center xl:justify-end relative">
          {/* --- For Extra Large & Wide Screens --- */}
          <div className="hidden xl:block relative">
            <img
              src={hire}
              alt="hire"
              className="
              mr-6
                w-[400px] xl:w-[460px] 2xl:w-[320px]
                object-contain
              "
            />
            {/* <img
              src={Lines}
              alt="lines"
              className="
                absolute
                -top-[85%] left-[12%]
                xl:-top-[105%] xl:left-[6%]
                2xl:-top-[120%] 2xl:left-[3%]
                w-[180px] xl:w-[210px] 2xl:w-[260px]
              "
            /> */}
          </div>

          {/* --- For Tablets & Mobiles --- */}
          <div className="block xl:hidden relative w-full max-w-[420px]">
            <img
              src={hire}
              alt="hire"
              className="mx-auto w-[280px] sm:w-[340px] object-contain"
            />
            {/* <img
              src={Lines}
              alt="lines"
              className="
                absolute
                hidden lg:block
                -top-[90%] sm:-top-[100%]
                left-[35%] sm:left-[40%]
                w-[130px] sm:w-[160px]
              "
            /> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hire;
